import styled from 'styled-components';
import { SelectProps } from './Select';
import { field } from '../panel';

export const SelectElement = styled.select<SelectProps>`
  outline: none;
  appearance: none;
  ${field};
  height: 44px;
  text-overflow: ellipsis;
  padding-top: 0;
  padding-bottom: 0;
  padding-left: 12px;
  padding-right: ${(p) => p.theme.spacing.lg};
  background-repeat: no-repeat;
  background-size: 20px;
  background-image: url('/icons/chevron.svg');
  background-position: calc(100% - 14px);
  font-size: ${(p) => p.theme.font.size.sm};
  ${(p) => p.error && `border-color: ${p.theme.colors.general.error};`}
  width: ${(p) => (p.fullWidth ? '100%' : 'auto')};
  @media (max-width: ${(p) => p.theme.screen.xs}) {
    font-size: ${(p) => p.theme.font.size.xs};
  }
  // border-right: ${(p) => p.theme.spacing.xs} solid transparent;
`;
